import { processUpdatedInspectionState, updatedCategoriesResponse, updatedCategoryLinesResponse, updateInspectionMediaData, updateNarrativeComment } from "../../Helpers/HelperFunctions";
import ACTION_TYPES from "../Constants/ActionTypes";
const initialState = {
  reorderCategory: false,
  getClListStatus: true,
  bulkUploadMediaLength: 0,
  successfulBulkUploadMediaLength: 0,
  failBulkUploadMediaLength: 0,
};
// eslint-disable-next-line
export default (state = initialState, { type, payload }) => {
  switch (type) {
    // COMMENTS
    case ACTION_TYPES.LOAD_DASHBOARD_RESPONSE:
      return { ...state, dashboardData: payload };
    case ACTION_TYPES.GET_INSPECTION_RESPONSE: {
      const newPayload = payload?.data?.inspectiontemplates?.filter((obj) => obj.is_deleted !== 1);
      return {
        ...state,
        inspectionData: { ...payload, data: { ...payload?.data, inspectiontemplates: newPayload } },
        inspectionDataForBulkMedia: payload,
        loader: false,
        mediaUpdate: false,
        scrolPage: false,
        isnTempateUpdate: "",
        staticBG: false,
        addCommentResponse: "",
        clCommentAdded: false,
        clCommentStatusChanged: false,
        getClListStatus: true,
        narrativeCommentAdded: "",
        isBulkUploaded: false,
      };
    }
    case ACTION_TYPES.GET_INSPECTION_RESPONSE_FOR_BULK_MEDIA:
      return {
        ...state,
        inspectionDataForBulkMedia: payload,
        loader: false,
        mediaUpdate: false,
        scrolPage: false,
        isnTempateUpdate: "",
        staticBG: false,
        addCommentResponse: "",
        clCommentAdded: false,
        clCommentStatusChanged: false,
        getClListStatus: true,
        narrativeCommentAdded: "",
        isBulkUploaded: false,
      };
    case ACTION_TYPES.SEND_DATA_TO_READ_SECTION_OFFLINE: {
      const newPayload = payload?.data?.inspectiontemplates?.filter((obj) => obj.is_deleted !== 1);
      return {
        ...state,
        inspectionData: { ...state?.inspectionData, data: { ...state?.inspectionData?.data, inspectiontemplates: newPayload } },
        // loader: true,
        mediaUpdate: false,
        scrolPage: false,
        isnTempateUpdate: "",
        staticBG: false,
      };
    }
    case ACTION_TYPES.GET_INSPECTION_LOADER:
      return { ...state, loader: true, mediaUpdate: false };
    case ACTION_TYPES.GET_ADD_CAT_LOADER:
      return { ...state, addCatLoader: true, mediaUpdate: false };
    case ACTION_TYPES.GET_ADD_LINE_LOADER:
      return { ...state, addLineLoader: true, mediaUpdate: false };
    case ACTION_TYPES.GET_LOADER_FOR_TEMPLATE_UPDATE:
      return { ...state, loader: false, mediaUpdate: false, templateUpdateLoader: true };
    case ACTION_TYPES.GET_INSPECTION_ERROR:
      return { ...state, inspectionDataError: payload, loader: false, mediaUpdate: false, scrolPage: false };
    case ACTION_TYPES.UPDATE_INSPECTION_RESPONSE: {
      const newPayload = payload?.data?.inspectiontemplates;
      const updatedInspectionData = processUpdatedInspectionState(state?.inspectionData, payload?.data, newPayload, state?.inspectionDataForBulkMedia);
      return {
        ...state,
        inspectionData: updatedInspectionData,
        inspectionDataForBulkMedia: { ...state.inspectionDataForBulkMedia, data: { ...state?.inspectionDataForBulkMedia?.data, inspectiontemplates: updatedInspectionData?.data?.inspectiontemplates, report_media_library_files: updatedInspectionData?.data?.hasOwnProperty("report_media_library_files") ? updatedInspectionData?.data?.report_media_library_files : state?.inspectionDataForBulkMedia?.data?.report_media_library_files } },
        updatedInspectionData: { ...payload, data: { ...payload?.data, inspectiontemplates: updatedInspectionData?.data?.inspectiontemplates } },
        loader: false,
        mediaUpdate: false,
        scrolPage: false,
        addCommentResponse: "",
      };
    }
    case ACTION_TYPES.DELETE_INSPECTION_MEDIA_RESPONSE: {
      const newPayload = payload?.data?.inspectiontemplates?.filter((obj) => obj.is_deleted !== 1);
      return {
        ...state,
        inspectionDataForBulkMedia: payload,
        mediaUpdated: { ...payload, data: { ...payload?.data, inspectiontemplates: newPayload } },
        inspectionData: { ...payload, data: { ...payload?.data, inspectiontemplates: newPayload } },
        updatedInspectionData: { ...payload, data: { ...payload?.data, inspectiontemplates: newPayload } },
        loader: false,
        mediaUpdate: false,
        scrolPage: false,
        addCommentResponse: "",
      };
    }
    case ACTION_TYPES.UPDATE_INSPECTION_RESPONSE_FOR_ADD_INP: {
      const newPayload = payload?.data?.inspectiontemplates?.filter((obj) => obj.is_deleted !== 1);
      return {
        ...state,
        inspectionData: { ...payload, data: { ...payload?.data, inspectiontemplates: newPayload } },
        inspectionDataForBulkMedia: payload,
        updatedInspectionData: { ...payload, data: { ...payload?.data, inspectiontemplates: newPayload } },
        loader: false,
        mediaUpdate: false,
        addInpUpdated: true,
        scrolPage: false,
      };
    }
    case ACTION_TYPES.CLEAR_UPDATED_INSPECTION_DATA:
      return { ...state, updatedInspectionData: "", scrolPage: false };
    case ACTION_TYPES.CLEAR_UPDATED_TEMPLATE_DATA:
      return { ...state, attachmentUpdate: false, attachmentResponse: "", scrolPage: false };
    // case ACTION_TYPES.CLEAR_INSPECTION_DATA_ERROR:
    //   return { ...state,inspectionDataError:'' };
    case ACTION_TYPES.UPDATE_INSPECTION_ERROR:
      return { ...state, updatedInspectionData: payload, scrolPage: false };
    case ACTION_TYPES.UPDATE_INSPECTION_ERROR_FOR_ADD_INP:
      return { ...state, updatedInspectionData: payload, addInpUpdated: true, scrolPage: false };
    // case ACTION_TYPES.REORDER_CATEGORY:
    //   return { ...state, reorderCategory: true };
    // activate categories and lines
    case ACTION_TYPES.ACTIVATE_CURRENT_LINE:
      return { ...state, loader: false, scrolPage: false, activeLineUuid: payload };
    case ACTION_TYPES.CLEAR_ACTIVATED_CURRENT_LINE:
      return { ...state, loader: false, scrolPage: false, activeLineUuid: "" };
    // getcategory and line list
    case ACTION_TYPES.SCROLL_PAGE_TOP:
      return { ...state, loader: false, scrolPage: true };
    case ACTION_TYPES.SET_STATIC_BACKGROUND:
      return { ...state, staticBG: payload };
    case ACTION_TYPES.GET_CATEGORY_LIST_RESPONSE:
      return { ...state, loader: false, defaultCategoryList: payload, addCatLoader: false };
    case ACTION_TYPES.GET_CATEGORY_LIST_ERROR:
      return { ...state, loader: false, defaultCategoryList: [], addCatLoader: false };
    case ACTION_TYPES.GET_CATEGORY_LIST_DATA_SUCCESS:
      return { ...state, loader: false, defaultCategoryListData: payload, scrolPage: false };
    case ACTION_TYPES.GET_CATEGORY_LIST_DATA_ERROR:
      return { ...state, loader: false, defaultCategoryListData: [], scrolPage: false };
    // Add and delete templates api
    case ACTION_TYPES.GET_TEMPLATE_LIST_RESPONSE:
      return { ...state, loader: false, defaultTemplateList: payload, addCatLoader: false };
    case ACTION_TYPES.GET_TEMPLATE_LIST_ERROR:
      return { ...state, loader: false, defaultTemplateList: [], addCatLoader: false };
    case ACTION_TYPES.SWAP_INSPECTION_DETAILS_RESPONSE:
      return { ...state, loader: false, swapInspectionDetails: payload, addCatLoader: false };
    case ACTION_TYPES.SWAP_INSPECTION_DETAILS_ERROR:
      return { ...state, loader: false, swapInspectionDetails: [], addCatLoader: false };
    // DELETED TEMPLATED DATA
    case ACTION_TYPES.GET_DELETED_TEMPLATE_DATA_RESPONSE:
      return { ...state, loader: false, deletedTemplateData: payload, addCatLoader: false };
    case ACTION_TYPES.GET_DELETED_TEMPLATE_DATA_ERROR:
      return { ...state, loader: false, deletedTemplateData: [], addCatLoader: false };
    //default lines
    case ACTION_TYPES.GET_CATEGORY_LINE_LIST_RESPONSE:
      return { ...state, loader: false, defaultLineData: payload, addLineLoader: false, scrolPage: false,lineDataError: null };
    case ACTION_TYPES.GET_CATEGORY_LINE_LIST_ERROR:
      return { ...state, loader: false, defaultLineData: [], addLineLoader: false, scrolPage: false,lineDataError: payload };
    // media
    case ACTION_TYPES.UPDATE_MEDIA_DATA:
      const updatedMediaData = updateInspectionMediaData(state?.inspectionData, payload?.payload, payload?.response);
      return {
        ...state,
        inspectionData: updatedMediaData,
        inspectionDataForBulkMedia: updatedMediaData
      };
    case ACTION_TYPES.UPLOAD_MEDIA_RESPONSE:
      const updatedMediaResponse = updateInspectionMediaData(state?.inspectionData, payload?.payload, payload?.response);
      return {
        ...state,
        loader: false,
        mediaEdited: true,
        inspectionData: updatedMediaResponse,
        inspectionDataForBulkMedia: updatedMediaResponse,
        updatedInspectionData: updatedMediaResponse,
      };
    case ACTION_TYPES.UPLOAD_MEDIA_ERROR:
      return { ...state, loader: false, mediaUpdate: true };
    case ACTION_TYPES.BULK_UPLOAD_RESPONSE:
      return { ...state, loader: false, mediaUpdate: true, isBulkUploaded: true, bulkUploadMediaLength: 0 };
    case ACTION_TYPES.BULK_UPLOAD_ERROR:
      return { ...state, loader: false, mediaUpdate: true, isBulkUploaded: false, bulkUploadMediaLength: 0 };
    case ACTION_TYPES.MARK_COMPLETE_RESPONSE:
      return { ...state, loader: false, markflow: true, markResponse: true };
    case ACTION_TYPES.MARK_COMPLETE_ERROR:
      return { ...state, loader: false, markflow: true, markResponse: false };
    case ACTION_TYPES.PORCH_PDF_GENERATE_RESPONSE:
      return { ...state, loader: false, markflow: true, markResponse: true };
    case ACTION_TYPES.PORCH_PDF_GENERATE_ERROR:
      return { ...state, loader: false, markflow: false, markResponse: false };
    // attachment
    case ACTION_TYPES.UPLOAD_ATTACHMENT_RESPONSE:
      return {
        ...state,
        loader: false,
        attachmentUpdate: true,
        attachmentResponse: payload,
        inspectionData: {
          ...state?.inspectionData,
          data: {
            ...state?.inspectionData?.data,
            attachments:
              payload?.data ?? state?.inspectionData?.data?.attachments,
          },
        },
        inspectionDataForBulkMedia: {
          ...state?.inspectionDataForBulkMedia,
          data: {
            ...state?.inspectionDataForBulkMedia?.data,
            attachments:
              payload?.data ?? state?.inspectionDataForBulkMedia?.data?.attachments,
          },
        },
        updatedInspectionData: {
          ...(state?.updatedInspectionData ?? state?.inspectionData ?? {}),
          data: {
            ...(state?.updatedInspectionData?.data ?? state?.inspectionData?.data ?? {}),
            attachments:
              payload?.data ??
              state?.updatedInspectionData?.data?.attachments ??
              state?.inspectionData?.data?.attachments,
          },
        },
      };
    case ACTION_TYPES.UPLOAD_ATTACHMENT_ERROR:
      return { ...state, loader: false, attachmentUpdate: true, attachmentResponse: payload };
    // duplicate lines
    case ACTION_TYPES.DUPLICATE_LINES_RESPONSE:
      const updatedCategoryLinesRedux = updatedCategoryLinesResponse(state?.inspectionData, payload?.payload, payload?.response);
      return {
        ...state, loader: false,
        inspectionData: updatedCategoryLinesRedux,
        inspectionDataForBulkMedia: { ...state.inspectionDataForBulkMedia, data: { ...state?.inspectionDataForBulkMedia?.data, inspectiontemplates: updatedCategoryLinesRedux?.data?.inspectiontemplates } },
        updatedInspectionData: { ...state.updatedInspectionData, data: { ...state?.updatedInspectionData?.data, inspectiontemplates: updatedCategoryLinesRedux?.data?.inspectiontemplates } },
      };
    case ACTION_TYPES.DUPLICATE_LINES_ERROR:
      return { ...state, loader: false, duplicateLineResponse: payload };
    case ACTION_TYPES.GET_DEFECT_DATA:
      return { ...state, loader: false, defectData: payload };
    // DUPLICATE CATEGORY
    // duplicate lines
    case ACTION_TYPES.DUPLICATE_CATEGORYS_RESPONSE:
      const updatedCategoriesRedux = updatedCategoriesResponse(state?.inspectionData, payload?.payload, payload?.response);
      return {
        ...state, loader: false,
        inspectionData: updatedCategoriesRedux,
        inspectionDataForBulkMedia: { ...state.inspectionDataForBulkMedia, data: { ...state?.inspectionDataForBulkMedia?.data, inspectiontemplates: updatedCategoriesRedux?.data?.inspectiontemplates } },
        updatedInspectionData: { ...state.updatedInspectionData, data: { ...state?.updatedInspectionData?.data, inspectiontemplates: updatedCategoriesRedux?.data?.inspectiontemplates } },
      };
    case ACTION_TYPES.DUPLICATE_CATEGORYS_ERROR:
      return { ...state, loader: false, duplicateCategoryResponse: payload };
    case ACTION_TYPES.ASSIGN_INSPECTOR_FLAG_TO_CATEGORY_RESPONSE:
      return {
        ...state,
        loader: false,
        inspectionData: {
          ...state.inspectionData,
          data: {
            ...state.inspectionData.data,
            inspectiontemplates:
              state.inspectionData?.data?.inspectiontemplates?.map((template) => {
                const isTemplateMatch =
                  template?.template_id == payload?.payload?.template_id &&
                  template?.template_guid == payload?.payload?.template_guid;
                if (!isTemplateMatch) return template;

                if (payload?.payload?.template_type == 3) {
                  return {
                    ...template,
                    pdf_categories: template?.pdf_categories?.map((category) =>
                      category?.id == payload?.payload?.category_id
                        ? {
                          ...category,
                          inspector_flagging_guids: payload?.response?.data,
                        }
                        : category
                    ),
                  };
                }
                return {
                  ...template,
                  categories: template?.categories?.map((category) =>
                    category?.id == payload?.payload?.category_id
                      ? { ...category, inspector_flagging_guids: payload?.response?.data, }
                      : category
                  ),
                };
              }),
          },
        },
      };
    case ACTION_TYPES.ASSIGN_INSPECTOR_FLAG_TO_CATEGORY_ERROR:
      return { ...state, loader: false, assignCategoryFlagToCategory: payload };
    case ACTION_TYPES.ASSIGN_INSPECTOR_FLAG_TO_LINE_RESPONSE:
      return {
        ...state,
        loader: false,
        inspectionData: {
          ...state.inspectionData,
          data: {
            ...state.inspectionData.data,
            inspectiontemplates:
              state.inspectionData?.data?.inspectiontemplates?.map((template) => {
                const isTemplateMatch =
                  template?.template_id == payload?.payload?.template_id &&
                  template?.template_guid == payload?.payload?.template_guid;

                if (!isTemplateMatch) return template;

                return {
                  ...template,
                  categories: template?.categories?.map((category) => {
                    const isCategoryMatch =
                      category?.id == payload?.payload?.category_id;
                    if (!isCategoryMatch) return category;

                    return {
                      ...category,
                      lines: category?.lines?.map((line) =>
                        line?.uuid == payload?.payload?.line_uuid
                          ? {
                            ...line,
                            inspector_flagging_guids: payload?.response?.data,
                          }
                          : line
                      ),
                    };
                  }),
                };
              }),
          },
        },
      };
    case ACTION_TYPES.ASSIGN_INSPECTOR_FLAG_TO_LINE_ERROR:
      return { ...state, loader: false, assignCategoryFlagToLine: payload };
    case ACTION_TYPES.EDIT_INSPECTOR_FLAG_LIST_RESPONSE:
      return {
        ...state,
        loader: false,
        inspectionData: {
          ...state?.inspectionData,
          data: {
            ...state?.inspectionData?.data,
            inspectorFlagList: payload?.response?.data,
          },
        },
      };
    case ACTION_TYPES.EDIT_INSPECTOR_FLAG_LIST_ERROR:
      return { ...state, loader: false, editinspectorFlagList: payload };
    case ACTION_TYPES.DELETE_INTRODUCTORY_TEXT_MEDIA:
      return { ...state, loader: false, deleteIntroductoryTextMedia: payload };
    case ACTION_TYPES.DELETE_INTRODUCTORY_TEXT_MEDIA_ERROR:
      return { ...state, loader: false, deleteIntroductoryTextMedia: payload };
    case ACTION_TYPES.INTRODUCTORY_TEXT_MEDIA:
      return { ...state, loader: false, introductoryTextMedia: payload };
    case ACTION_TYPES.INTRODUCTORY_TEXT_MEDIA_ERROR:
      return { ...state, loader: false, introductoryTextMedia: payload };
    // ISN MARK complete
    case ACTION_TYPES.MARK_COMPLETE_RESPONSE_ISN:
      return { ...state, loader: false, markflow: true, markResponse: true, markCompleteResponse: payload.data };
    case ACTION_TYPES.MARK_COMPLETE_ERROR_ISN:
      return { ...state, loader: false, markflow: true, markResponse: false };
    case ACTION_TYPES.MARK_COMPLETE_ISN_SEND_REPORT_RESPONSE:
      return { ...state, loader: false, reportSend: true, markCompleteResponse: payload.data };
    case ACTION_TYPES.MARK_COMPLETE_ISN_SEND_REPORT_ERROR:
      return { ...state, loader: false, reportSend: false };
    // edit lines and categories
    case ACTION_TYPES.EDIT_CAT_STATUS:
      return { ...state, loader: false, markflow: true, markResponse: false, editCategory: payload };
    case ACTION_TYPES.EDIT_LINE_STATUS:
      return { ...state, loader: false, markflow: true, markResponse: false, editCategory: false, editLine: payload };
    //reorder
    case ACTION_TYPES.REORDER_CATEGORY_STATUS:
      return { ...state, loader: false, markflow: true, markResponse: false, reorderCategory: payload };
    case ACTION_TYPES.BULK_UPLOAD_MEDIA_LENGTH_STATUS:
      return { ...state, loader: false, markResponse: false, bulkUploadMediaLength: payload };
    case ACTION_TYPES.SUCCESSFUL_BULK_UPLOAD_MEDIA_LENGTH_STATUS:
      return { ...state, loader: false, markResponse: false, successfulBulkUploadMediaLength: payload };
    case ACTION_TYPES.FAIL_BULK_UPLOAD_MEDIA_LENGTH_STATUS:
      return { ...state, loader: false, markResponse: false, failBulkUploadMediaLength: payload };
    case ACTION_TYPES.FAILED_BULK_UPLOAD_MEDIA_STATUS:
      return { ...state, loader: false, markResponse: false, failedBulkUploadMedia: payload };
    case ACTION_TYPES.BULK_UPLOADING_STAUS:
      return { ...state, loader: false, markResponse: false, isbulkUploading: payload };
    case ACTION_TYPES.REORDER_LINES_STATUS:
      return { ...state, loader: false, markflow: true, markResponse: false, reorderCategory: false, reorderLines: payload };
    // ISN
    case ACTION_TYPES.GET_MASTER_TEMPLATES_SUCCESS:
      return { ...state, loader: false, IsnMasterTemplates: payload?.data };
    case ACTION_TYPES.GET_MASTER_TEMPLATES_ERROR:
      return { ...state, loader: false, IsnMasterTemplates: [] };
    case ACTION_TYPES.UPDATE_ISN_TEMPLATE_RESPONSE:
      return { ...state, loader: false, isnTempateUpdate: "success", templateUpdateLoader: false };
    case ACTION_TYPES.UPDATE_ISN_TEMPLATE_ERROR:
      return { ...state, loader: false, isnTempateUpdate: "fail", templateUpdateLoader: false };
    //comment library
    case ACTION_TYPES.GET_COMMENT_LIBRARY_LIST_LOADER:
      return { ...state, addCommentListLoader: true, mediaUpdate: false };
    case ACTION_TYPES.INTRODUCTORY_TEXT_MEDIA_RESPONSE: {
      const withCategoryMedia = (inspectionState) => ({
        ...inspectionState,
        data: {
          ...inspectionState?.data,
          inspectiontemplates:
            inspectionState?.data?.inspectiontemplates?.map((template) => {
              const isTemplateMatch = template?.template_id == payload?.payload?.template_id;
              if (!isTemplateMatch) return template;
              return {
                ...template,
                categories: template?.categories?.map((category) =>
                  category?.id == payload?.payload?.category_id
                    ? { ...category, introductory_text_media: payload?.response?.data, }
                    : category
                ),
              };
            }),
        },
      });
      return {
        ...state,
        loader: false,
        inspectionData: withCategoryMedia(state.inspectionData),
        // The media library popups count usage from this copy, so category media must land here too
        inspectionDataForBulkMedia: withCategoryMedia(state.inspectionDataForBulkMedia),
      };
    }
    case ACTION_TYPES.GET_COMMENT_LIBRARY_LIST_RESPONSE:
      return {
        ...state,
        loader: false,
        commentLibraryListData: payload,
        getClListStatus: true,
        totalListCount: payload?.total,
        addCommentListLoader: false,
        scrolPage: false,
        addCommentResponse: "",
        clCommentAdded: false,
        clCommentStatusChanged: false,
        narrativeCommentAdded: "",
      };
    case ACTION_TYPES.GET_COMMENT_LIBRARY_LIST_NNT_RESPONSE:
      return {
        ...state,
        loader: false,
        commentLibraryListDataNnt: payload,
      };
    case ACTION_TYPES.CLEAR_COMMENT_LIBRARY_LIST_NNT_RESPONSE:
      return {
        ...state,
        commentLibraryListDataNnt: [],
        defaultCategories: null,
        defaultCategoriesApiStatus: null,
      };
    case ACTION_TYPES.GET_COMMENT_LIBRARY_LIST_ERROR:
      return {
        ...state,
        loader: false,
        commentLibraryListData: payload?.response,
        getClListStatus: false,
        totalListCount: 0,
        addCommentListLoader: false,
        scrolPage: false,
        addCommentResponse: "",
        clCommentAdded: false,
        clCommentStatusChanged: false,
        narrativeCommentAdded: "",
      };
    case ACTION_TYPES.VALIDATE_CATGEORY_LINE_RELATION_RESPONSE:
      return { ...state, categoryLineRelation: payload };
    case ACTION_TYPES.VALIDATE_CATGEORY_LINE_RELATION_ERROR:
      return { ...state, categoryLineRelation: payload };
    case ACTION_TYPES.ADD_COMMENT_TOREPORT_FROM_CL_RESPONSE:
      return {
        ...state,
        loader: false,
        scrolPage: false,
        addCommentResponse: payload?.response,
        clCommentAdded: true,
        inspectionData: updateNarrativeComment(state?.inspectionData, payload, payload?.response),
        inspectionDataForBulkMedia: updateNarrativeComment(state?.inspectionDataForBulkMedia, payload, payload?.response),
        updatedInspectionData: updateNarrativeComment(state?.updatedInspectionData, payload, payload?.response),
      };
    case ACTION_TYPES.ADD_COMMENT_TOREPORT_FROM_CL_ERROR:
      return { ...state, scrolPage: false, addCommentResponse: payload, clCommentAdded: false };
    case ACTION_TYPES.UPDATE_CL_COMMENT_STATUS_RESPONSE:
      return { ...state, loader: false, scrolPage: false, clCommentChangeStatus: payload, clCommentStatusChanged: true };
    case ACTION_TYPES.UPDATE_CL_COMMENT_STATUS_ERROR:
      return { ...state, scrolPage: false, clCommentChangeStatus: payload, clCommentStatusChanged: false };
    case ACTION_TYPES.ADD_NEW_NARRATIVE_COMMENT_RESPONSE:
      return { ...state, loader: false, scrolPage: false, narrativeCommentAdded: true, addNarrativeCommentResponse: payload };
    case ACTION_TYPES.ADD_NEW_NARRATIVE_COMMENT_ERROR:
      return { ...state, scrolPage: false, narrativeCommentAdded: false, addNarrativeCommentResponse: payload };
    case ACTION_TYPES.GET_COMMENT_LIBRARY_TAG_LIST_RESPONSE:
      return { ...state, loader: false, clTag: payload, getClTagStatus: true };
    case ACTION_TYPES.GET_COMMENT_LIBRARY_TAG_LIST_NN_RESPONSE:
      return { ...state, loader: false, clTagNN: payload, getClTagNAStatus: true };
    case ACTION_TYPES.GET_COMMENT_LIBRARY_TAG_LIST_ERROR:
      return { ...state, loader: false, clTag: payload.response, getClTagStatus: true };
    case ACTION_TYPES.GET_COMMENT_LIBRARY_SUMMARY_TAG_LIST_RESPONSE:
      return { ...state, loader: false, clSummaryTag: payload, getClSummaryStatus: true };
    case ACTION_TYPES.GET_COMMENT_LIBRARY_SUMMARY_TAG_LIST_ERROR:
      return { ...state, loader: false, clSummaryTag: payload.response, getClSummaryStatus: true };
    case ACTION_TYPES.UPDATE_DROPDOWNVALUES_RESPONSE: {
      let newData = state.commentLibraryListData.data;
      const commentIndex = newData.findIndex((item) => item.id === parseInt(payload?.comment_id));
      const dropdownIndex = newData[commentIndex]?.comment_dropdowns.findIndex((item) => item.dropdown_uuid === payload?.dropdown_uuid);
      const summaryIndex = newData[commentIndex]?.summary_comment_dropdowns.findIndex((item) => item.dropdown_uuid === payload?.dropdown_uuid);
      newData[commentIndex].comment_dropdowns[dropdownIndex] = { ...newData[commentIndex].comment_dropdowns[dropdownIndex], selected_value: payload?.selected_value };
      newData[commentIndex].summary_comment_dropdowns[summaryIndex] = { ...newData[commentIndex].summary_comment_dropdowns[summaryIndex], selected_value: payload?.selected_value };
      return { ...state, loader: false, dropdownChanged: true, commentLibraryListData: { ...state.commentLibraryListData, data: newData } };
    }
    case ACTION_TYPES.UPDATE_INPUT_VALUES_RESPONSE: {
      let newData = state.commentLibraryListData.data;
      console.log("payload", payload)
      const commentIndex = newData.findIndex((item) => item.uuid === payload?.comment_uuid);
      console.log("commentIndex", commentIndex)

      if (payload?.comment_text !== undefined && payload?.comment_text !== null) {
        newData[commentIndex].comment_text = payload?.comment_text
      } else {
        newData[commentIndex].summary_comment_text = payload?.summary_comment_text
      }
      console.log("newData", newData)
      return { ...state, loader: false, commentLibraryListData: { ...state.commentLibraryListData, data: newData } };
    }
    case ACTION_TYPES.UPDATE_DROPDOWNVALUES_ERROR:
      return { ...state, loader: false, dropdownChanged: false };
    // report library
    case ACTION_TYPES.UPDATE_REPORT_SIDEBAR_STATUS:
      return { ...state, loader: false, scrolPage: false, reportSideBarActive: payload };
    case ACTION_TYPES.SHOW_COMMENT_LIBRARY_MODAL:
      return { ...state, showCommentLibraryModal: payload };
    case ACTION_TYPES.SAVE_INTRO_TEXT_RESPONSE: {
      const rawIncoming = payload?.introductory_text_dropdowns;
      const incomingDropdowns = Array.isArray(rawIncoming) ? rawIncoming
        : Array.isArray(rawIncoming?.introductory_text_dropdowns) ? rawIncoming.introductory_text_dropdowns : [];
      const updatedTemplates = state?.inspectionData?.data?.inspectiontemplates?.map((item) => {
        if (item.template_id !== payload?.template_id) return item;
        return {
          ...item,
          categories: item.categories?.map((category) => {
            if (category?.id !== payload?.category_id) return category;
            const rawExisting = category.introductory_text_dropdowns;
            const existingDropdowns = Array.isArray(rawExisting) ? rawExisting
              : Array.isArray(rawExisting?.introductory_text_dropdowns) ? rawExisting.introductory_text_dropdowns : [];
            let mergedDropdowns = existingDropdowns;
            if (incomingDropdowns.length > 0) {
              const merged = existingDropdowns.map((d) => {
                const updated = incomingDropdowns.find((u) => u.dropdown_uuid === d.dropdown_uuid);
                return updated ? { ...d, ...updated } : d;
              });
              incomingDropdowns.forEach((u) => {
                if (!merged.find((d) => d.dropdown_uuid === u.dropdown_uuid)) {
                  merged.push(u);
                }
              });
              mergedDropdowns = merged;
            }
            return {
              ...category,
              ...('introductory_text' in (payload || {}) ? { introductory_text: payload.introductory_text } : {}),
              introductory_text_dropdowns: mergedDropdowns,
            };
          }),
        };
      });
      return {
        ...state,
        inspectionData: {
          ...state?.inspectionData,
          data: {
            ...state?.inspectionData?.data,
            inspectiontemplates: updatedTemplates,
          },
        },
      };
    }
    case ACTION_TYPES.SET_DEFAULT_CATEGORIES:
      return { ...state, loader: false, defaultCategories: payload.data, defaultCategoriesApiStatus: payload.status };
    case ACTION_TYPES.CLEAR_DEFAULT_CATEGORIES:
      return { ...state, loader: false, defaultCategories: [] };
    case ACTION_TYPES.SET_DEFAULT_CATEGORIES_ERROR:
      return { ...state, loader: false };
    case ACTION_TYPES.SAVE_INTRO_TEXT_ERROR:
      return { ...state, loader: false };
    case ACTION_TYPES.GET_USERS_LIST_RESPONSE: {
      return { ...state, userDataList: payload };
    }
    case ACTION_TYPES.GET_USERS_LIST_ERROR:
      return { ...state, loader: false };
    case ACTION_TYPES.UPDATE_COMMENT_DATA: {
      return { ...state, inspectionData: { ...state.inspectionData, data: payload } };
    }
    case 'UPDATE_SINGLE_LINE_INPUT_CONTROL': {
      const {
        templateId,
        categoryId,
        lineUuid,
        lineInputControlId,
        updatedValues
      } = payload;

      const newState = JSON.parse(JSON.stringify(state)); // or use immer for better perf

      const template = newState.inspectionData.data.inspectiontemplates.find(t => t.template_id === templateId);
      const category = template.categories.find(c => c.id === categoryId);
      const line = category.lines.find(l => l.uuid === lineUuid);
      const control = line.line_input_controls.find(c => c.uuid === lineInputControlId);

      if (control) {
        control.values = updatedValues;
        control.updated_at = new Date().toISOString().replace("T", " ").substring(0, 19);
        control.data = updatedValues.filter(v => v.is_selected).map(v => v.value);
      }

      return newState;
    }

    default:
      return state;
  }
};
